import React, { useState } from 'react';
import { ShoppingCart, Clock, CheckCircle2, Truck, FileText, Search, Filter, Plus, ArrowRight, MoreVertical, X, Calendar, DollarSign, Trash2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const orderStates = [{
  id: 'draft',
  label: 'Draft',
  icon: FileText,
  color: 'slate'
}, {
  id: 'pending',
  label: 'Pending Approval',
  icon: Clock,
  color: 'amber'
}, {
  id: 'approved',
  label: 'Approved',
  icon: CheckCircle2,
  color: 'emerald'
}, {
  id: 'submitted',
  label: 'Submitted',
  icon: Truck,
  color: 'blue'
}, {
  id: 'received',
  label: 'Received',
  icon: ShoppingCart,
  color: 'indigo'
}];
export function OrderGeneration() {
  const [activeState, setActiveState] = useState('pending');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newOrder, setNewOrder] = useState({
    vendor: 'Sysco Foods',
    orderDate: new Date().toISOString().split('T')[0],
    deliveryDate: '',
    items: [{
      id: '1',
      name: '',
      qty: 0,
      unit: 'Case',
      price: 0
    }],
    notes: ''
  });
  const addItem = () => {
    setNewOrder({
      ...newOrder,
      items: [...newOrder.items, {
        id: Math.random().toString(36).substr(2, 9),
        name: '',
        qty: 0,
        unit: 'Case',
        price: 0
      }]
    });
  };
  const removeItem = (id: string) => {
    setNewOrder({
      ...newOrder,
      items: newOrder.items.filter(item => item.id !== id)
    });
  };
  const updateItem = (id: string, field: string, value: any) => {
    setNewOrder({
      ...newOrder,
      items: newOrder.items.map(item => item.id === id ? {
        ...item,
        [field]: value
      } : item)
    });
  };
  const calculateTotal = () => {
    return newOrder.items.reduce((sum, item) => sum + item.qty * item.price, 0);
  };
  return <div className="space-y-6" data-id="element-766">
      <div className="flex items-center gap-2 border-b border-slate-100 overflow-x-auto no-scrollbar" data-id="element-767">
        {orderStates.map(state => <button key={state.id} onClick={() => setActiveState(state.id)} className={`flex items-center gap-2 px-4 py-3 text-sm font-bold whitespace-nowrap border-b-2 transition-all ${activeState === state.id ? 'border-emerald-500 text-emerald-600' : 'border-transparent text-slate-400 hover:text-slate-600'}`} data-id="element-768">
            <state.icon size={16} data-id="element-769" />
            {state.label}
          </button>)}
      </div>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-770">
        <div className="flex items-center gap-4 flex-1 max-w-2xl" data-id="element-771">
          <div className="relative flex-1" data-id="element-772">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} data-id="element-773" />
            <input type="text" placeholder="Search orders or vendors..." className="w-full pl-10 pr-4 py-2 bg-white border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" data-id="element-774" />
          </div>
          <button className="p-2 bg-white border border-slate-200 rounded-xl text-slate-600 hover:bg-slate-50 transition-all shadow-sm" data-id="element-775">
            <Filter size={18} data-id="element-776" />
          </button>
        </div>
        <button onClick={() => setIsModalOpen(true)} className="flex items-center gap-2 px-6 py-2 bg-slate-900 text-white rounded-xl text-sm font-bold hover:bg-slate-800 transition-all shadow-lg shadow-slate-900/20" data-id="element-777">
          <Plus size={16} data-id="element-778" />
          New Manual Order
        </button>
      </div>

      <AnimatePresence data-id="element-779">
        {isModalOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-780">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-white rounded-3xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col" data-id="element-781">
              <div className="px-8 py-6 border-b border-slate-100 flex items-center justify-between bg-slate-50/50" data-id="element-782">
                <div data-id="element-783">
                  <h3 className="text-xl font-bold text-slate-900" data-id="element-784">
                    Create Manual Purchase Order
                  </h3>
                  <p className="text-sm text-slate-500 font-medium" data-id="element-785">
                    Generate a new order for manual submission
                  </p>
                </div>
                <button onClick={() => setIsModalOpen(false)} className="p-2 hover:bg-slate-200 rounded-full transition-colors text-slate-400 hover:text-slate-600" data-id="element-786">
                  <X size={20} data-id="element-787" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-8" data-id="element-788">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-789">
                  <div data-id="element-790">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-791">
                      Vendor
                    </label>
                    <select className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={newOrder.vendor} onChange={e => setNewOrder({
                  ...newOrder,
                  vendor: e.target.value
                })} data-id="element-792">
                      <option data-id="element-793">Sysco Foods</option>
                      <option data-id="element-794">Profish</option>
                      <option data-id="element-795">Washington Wholesales</option>
                      <option data-id="element-796">US Foods</option>
                      <option data-id="element-797">Local Farmers</option>
                    </select>
                  </div>
                  <div data-id="element-798">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-799">
                      Order Date
                    </label>
                    <div className="relative" data-id="element-800">
                      <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={14} data-id="element-801" />
                      <input type="date" className="w-full pl-8 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={newOrder.orderDate} onChange={e => setNewOrder({
                    ...newOrder,
                    orderDate: e.target.value
                  })} data-id="element-802" />
                    </div>
                  </div>
                  <div data-id="element-803">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-804">
                      Expected Delivery
                    </label>
                    <div className="relative" data-id="element-805">
                      <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={14} data-id="element-806" />
                      <input type="date" className="w-full pl-8 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={newOrder.deliveryDate} onChange={e => setNewOrder({
                    ...newOrder,
                    deliveryDate: e.target.value
                  })} data-id="element-807" />
                    </div>
                  </div>
                </div>

                <div className="space-y-4" data-id="element-808">
                  <div className="flex items-center justify-between" data-id="element-809">
                    <h4 className="text-sm font-bold text-slate-900 uppercase tracking-wider" data-id="element-810">
                      Order Items
                    </h4>
                    <button onClick={addItem} className="flex items-center gap-1 text-xs font-bold text-emerald-600 hover:text-emerald-700 transition-colors" data-id="element-811">
                      <Plus size={14} data-id="element-812" /> Add Item
                    </button>
                  </div>

                  <div className="bg-slate-50 rounded-2xl border border-slate-100 overflow-hidden" data-id="element-813">
                    <table className="w-full text-left border-collapse" data-id="element-814">
                      <thead data-id="element-815">
                        <tr className="border-b border-slate-200" data-id="element-816">
                          <th className="px-4 py-3 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-817">
                            Item Name
                          </th>
                          <th className="px-4 py-3 text-[10px] font-bold text-slate-400 uppercase tracking-widest w-24" data-id="element-818">
                            Qty
                          </th>
                          <th className="px-4 py-3 text-[10px] font-bold text-slate-400 uppercase tracking-widest w-32" data-id="element-819">
                            Unit
                          </th>
                          <th className="px-4 py-3 text-[10px] font-bold text-slate-400 uppercase tracking-widest w-32" data-id="element-820">
                            Price
                          </th>
                          <th className="px-4 py-3 text-[10px] font-bold text-slate-400 uppercase tracking-widest w-32 text-right" data-id="element-821">
                            Total
                          </th>
                          <th className="px-4 py-3 text-[10px] font-bold text-slate-400 uppercase tracking-widest w-12" data-id="element-822"></th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100" data-id="element-823">
                        {newOrder.items.map(item => <tr key={item.id} className="bg-white/50" data-id="element-824">
                            <td className="px-4 py-2" data-id="element-825">
                              <input type="text" placeholder="Item name..." className="w-full bg-transparent text-sm font-bold outline-none focus:text-emerald-600" value={item.name} onChange={e => updateItem(item.id, 'name', e.target.value)} data-id="element-826" />
                            </td>
                            <td className="px-4 py-2" data-id="element-827">
                              <input type="number" className="w-full bg-transparent text-sm font-bold outline-none" value={item.qty} onChange={e => updateItem(item.id, 'qty', Number(e.target.value))} data-id="element-828" />
                            </td>
                            <td className="px-4 py-2" data-id="element-829">
                              <select className="w-full bg-transparent text-sm font-bold outline-none" value={item.unit} onChange={e => updateItem(item.id, 'unit', e.target.value)} data-id="element-830">
                                <option data-id="element-831">Case</option>
                                <option data-id="element-832">Each</option>
                                <option data-id="element-833">Pound</option>
                                <option data-id="element-834">Gallon</option>
                              </select>
                            </td>
                            <td className="px-4 py-2" data-id="element-835">
                              <div className="flex items-center gap-1" data-id="element-836">
                                <span className="text-slate-400" data-id="element-837">$</span>
                                <input type="number" className="w-full bg-transparent text-sm font-bold outline-none" value={item.price} onChange={e => updateItem(item.id, 'price', Number(e.target.value))} data-id="element-838" />
                              </div>
                            </td>
                            <td className="px-4 py-2 text-right text-sm font-black text-slate-900" data-id="element-839">
                              ${(item.qty * item.price).toFixed(2)}
                            </td>
                            <td className="px-4 py-2 text-right" data-id="element-840">
                              <button onClick={() => removeItem(item.id)} className="p-1 text-slate-300 hover:text-rose-500 transition-colors" data-id="element-841">
                                <Trash2 size={14} data-id="element-842" />
                              </button>
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-843">
                  <div data-id="element-844">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-845">
                      Order Notes
                    </label>
                    <textarea rows={3} placeholder="Special instructions for the vendor..." className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all resize-none" value={newOrder.notes} onChange={e => setNewOrder({
                  ...newOrder,
                  notes: e.target.value
                })} data-id="element-846" />
                  </div>
                  <div className="bg-slate-50 rounded-2xl p-6 flex flex-col justify-center items-end" data-id="element-847">
                    <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-848">
                      Estimated Total
                    </p>
                    <p className="text-4xl font-black text-emerald-600" data-id="element-849">
                      ${calculateTotal().toFixed(2)}
                    </p>
                  </div>
                </div>
              </div>

              <div className="px-8 py-6 border-t border-slate-100 bg-slate-50/50 flex items-center justify-end gap-3" data-id="element-850">
                <button onClick={() => setIsModalOpen(false)} className="px-6 py-2.5 text-sm font-bold text-slate-600 hover:bg-slate-200 rounded-xl transition-all" data-id="element-851">
                  Cancel
                </button>
                <button onClick={() => setIsModalOpen(false)} className="px-8 py-2.5 bg-slate-900 text-white rounded-xl text-sm font-bold hover:bg-slate-800 transition-all shadow-lg shadow-slate-900/20" data-id="element-852">
                  Create & Draft Order
                </button>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      <div className="grid grid-cols-1 gap-4" data-id="element-853">
        {[1, 2, 3].map(i => <div key={i} className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden hover:border-emerald-200 transition-all group" data-id="element-854">
            <div className="p-6 flex flex-col md:flex-row md:items-center justify-between gap-6" data-id="element-855">
              <div className="flex items-start gap-4" data-id="element-856">
                <div className="w-12 h-12 bg-slate-50 rounded-2xl flex items-center justify-center text-slate-400 group-hover:bg-emerald-50 group-hover:text-emerald-600 transition-colors" data-id="element-857">
                  <ShoppingCart size={24} data-id="element-858" />
                </div>
                <div data-id="element-859">
                  <div className="flex items-center gap-2 mb-1" data-id="element-860">
                    <h4 className="text-lg font-black text-slate-900" data-id="element-861">
                      PO-2025-00{i}
                    </h4>
                    <span className="px-2 py-0.5 bg-amber-50 text-amber-600 text-[10px] font-black rounded uppercase border border-amber-100" data-id="element-862">
                      Pending Approval
                    </span>
                  </div>
                  <p className="text-sm font-bold text-slate-500" data-id="element-863">
                    Sysco Foods • Jan 12, 2025
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-8" data-id="element-864">
                <div className="text-right" data-id="element-865">
                  <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-866">
                    Items
                  </p>
                  <p className="text-lg font-black text-slate-900" data-id="element-867">12</p>
                </div>
                <div className="text-right" data-id="element-868">
                  <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-869">
                    Total Value
                  </p>
                  <p className="text-lg font-black text-emerald-600" data-id="element-870">
                    $1,450.25
                  </p>
                </div>
                <div className="flex items-center gap-2" data-id="element-871">
                  <button className="px-4 py-2 bg-emerald-500 text-white rounded-xl text-xs font-bold hover:bg-emerald-600 transition-all shadow-md" data-id="element-872">
                    Approve Order
                  </button>
                  <button className="p-2 text-slate-400 hover:text-slate-600" data-id="element-873">
                    <MoreVertical size={18} data-id="element-874" />
                  </button>
                </div>
              </div>
            </div>
            <div className="px-6 py-4 bg-slate-50/50 border-t border-slate-50 flex items-center justify-between" data-id="element-875">
              <div className="flex items-center gap-4" data-id="element-876">
                <div className="flex -space-x-2" data-id="element-877">
                  {[1, 2, 3].map(j => <div key={j} className="w-6 h-6 rounded-full bg-white border border-slate-200 flex items-center justify-center text-[8px] font-black text-slate-400" data-id="element-878">
                      IT
                    </div>)}
                </div>
                <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider" data-id="element-879">
                  +9 more items
                </p>
              </div>
              <button className="flex items-center gap-1 text-[10px] font-black text-emerald-600 uppercase hover:underline" data-id="element-880">
                View PO Details <ArrowRight size={12} data-id="element-881" />
              </button>
            </div>
          </div>)}
      </div>
    </div>;
}